// extracted by mini-css-extract-plugin
export default {"label":"VehicleTradeIn-module__label--YOxqK"};